import React from "react";

import { Editor, Element, Frame } from "@craftjs/core";
import { PageButton } from "./parts/PageButton";
import { PageContainer } from "./parts/PageContainer";
import { PageExploreCatalogue, PageExploreCatalogueTitle } from "./parts/PageExploreCatalogue";
import { PageFeatures, PageFeaturesButtonContainer, PageFeaturesDescriptionContainer, PageFeaturesPanelContainer, PageFeaturesTitleContainer } from "./parts/PageFeatures";
import { PageImageSlider, PanelDropLocation } from "./parts/PageImageSlider";
import { PageImageSliderPanel, PanelButtonContainer, PanelTitle } from "./parts/PageImageSliderPanel";
import { PageCardBottom, PageCardTop, PageMediaPanel } from "./parts/PageMediaPanel";
import { PageMetrics } from "./parts/PageMetrics";
import { PageText } from "./parts/PageText";
import { FeaturesPanelContent, PageFeaturesPanel } from "./parts/PageFeaturesPanel";
import { PageTestimonials, TestimonialDropLocation, TestimonialListTitle } from "./parts/PageTestimonials";
import { PageTestimonialPanel, TestimonialPanelAuthor, TestimonialPanelContent } from "./parts/PageTestimonialPanel";
import { PageCardListing, PageCardListingTitle } from "./parts/PageCardListing";
import { Box, Text } from "components/ui";
import { PageRichTextEditor } from "./parts/PageRichTextEditor";
import ErrorBox from "components/general/ErrorBox";
import { PageTwoColumnContent, TwoColumnRichTextContainer, TwoColumnRichTextContainer2, TwoColumnTitleContainer } from "./parts/PageTwoColumnContent";
import { PageCallToAction, PageCallToActionDescription, PageCallToActionTitle } from "./parts/PageCallToAction";
import { CoreValuesTitle, PageCoreValues } from "./parts/PageCoreValues";
import { HeaderDescription, HeaderTitle, PageHeader } from "./parts/PageHeader";
import { PageAccordion, AccordionListLocation, AccordionListTitle } from "./parts/PageAccordion";
import { AccordionPanelContent, AccordionPanelTitle, PageAccordionPanel } from "./parts/PageAccordionPanel";
import { PageImageGalleryTitle } from "./parts/PageImageGalleryTitle";
import { PageImageGallery } from "./parts/PageImageGallery";
import { PageImageGalleryPanel } from "./parts/PageImageGalleryPanel";
import { PageImageGalleryPanelTitle } from "./parts/PageImageGalleryPanelTitle";
import { PageVideo } from "./parts/PageVideo";
import { PageVideoTitle } from "./parts/PageVideoTitle";
import { PageTwoColumn, TwoColumnContainer, TwoColumnRichText } from "./parts/PageTwoColumn";
import { PageImage } from "./parts/PageImage";
import { PageTileListing, PageTileListingTitle, TileListingContainer } from "./parts/PageTileListing";
import { PageTile, TileDescription, TileImage, TileTitle } from "./parts/PageTile";
import { PageBenefitsSection } from "./parts/PageBenefitsSection";

type Props = {
	content: any;
};

export const PageRender = ({ content }: Props) => {
	if (typeof window === "undefined") {
		throw new Error("Simulated SSR failure");
	}

	return (
		// <ScrollView>
		<Box>
			<Editor
				resolver={{
					PageButton,
					PageText,
					PageContainer,

					PageMediaPanel,
					PageCardTop,
					PageCardBottom,

					PageImageSlider,
					PanelDropLocation,

					PageImageSliderPanel,
					PanelTitle,
					PanelButtonContainer,

					PageExploreCatalogue,
					PageExploreCatalogueTitle,

					PageTestimonials,
					TestimonialDropLocation,
					PageTestimonialPanel,
					TestimonialPanelAuthor,
					TestimonialPanelContent,
					TestimonialListTitle,

					PageFeatures,
					PageFeaturesTitleContainer,
					PageFeaturesPanelContainer,
					PageFeaturesDescriptionContainer,
					PageFeaturesButtonContainer,

					PageFeaturesPanel,
					FeaturesPanelContent,

					PageMetrics,

					PageCardListing,
					PageCardListingTitle,

					PageRichTextEditor,

					PageAccordion,
					PageAccordionPanel,
					AccordionListLocation,
					AccordionListTitle,
					AccordionPanelTitle,
					AccordionPanelContent,

					PageCallToAction,
					PageCallToActionTitle,
					PageCallToActionDescription,

					PageVideo,
					PageVideoTitle,

					PageImageGallery,
					PageImageGalleryPanel,
					PageImageGalleryPanelTitle,
					PageImageGalleryTitle,

					PageTwoColumnContent,
					TwoColumnTitleContainer,
					TwoColumnRichTextContainer,
					TwoColumnRichTextContainer2,

					PageCoreValues,
					CoreValuesTitle,

					PageHeader,
					HeaderTitle,
					HeaderDescription,

					PageTwoColumn,
					TwoColumnContainer,
					TwoColumnRichText,

					PageImage,

					PageTileListing,
					PageTileListingTitle,
					TileListingContainer,
					PageTile,
					TileTitle,
					TileDescription,
					TileImage,

					PageBenefitsSection,
				}}
				enabled={false}
			>
				<Frame json={content}>
					<Element canvas></Element>
				</Frame>
			</Editor>
		</Box>

		// </ScrollView>
	);
};
